<template>
  <model-form
    :model="shortenedUrl"
    modal-type="modal"
  >
    <div class="column">
      <div class="q-gutter-md items-start">
        <q-input
          v-model="shortenedUrl.urlType"
          disable
          class="col"
          label="Type"
          bottom-slots
        />
        <q-input
          v-model="shortenedUrl.description"
          class="col"
          label="Description"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
        />
        <q-input
          v-model="shortenedUrl.fullPath"
          :disable="shortenedUrl.urlType !== 'Custom'"
          class="col"
          :prefix="`${currentSite.hostname}/`"
          :rules="[val => !!val || 'Value is required']"
          label="Full Path"
          bottom-slots
          hint="Path to be shortened"
        />
        <q-input
          v-model="shortenedUrl.shortSlug"
          class="col"
          label="Short Path"
          placeholder="E.g. l2xf_w"
          :rules="[
            val => (!val || val.length >= 6) || 'Must be at least 6 digits or blank',
            val => checkRouteValid(val) || 'Must only contain valid characters [0-9][a-z][A-Z]'
          ]
          "
          bottom-slots
          hint="Path after shortening (if left blank we will generate one for you)"
        />
        <q-input
          v-model="shortenedUrl.shortUrl"
          class="col"
          label="Shortened URL"
          readonly
          placeholder="Generated After Save"
          bottom-slots
        >
          <q-btn
            icon="content_copy"
            @click="copyUrl"
          >
            <q-tooltip
              ref="copyUrlTooltip"
              no-parent-event
              :hide-delay="1"
            >
              {{ tooltipMessage }}
              <q-tooltip />
            </q-tooltip>
          </q-btn>
        </q-input>
        <div v-if="!shortenedUrl.isLocal">
          <span>
            <q-icon
              name="warning"
              size="sm"
              color="warning"
            />
            Warning: Changing the Short Path will make the previous short path no longer be accessable
          </span>
        </div>
      </div>
    </div>
  </model-form>
</template>
<script>

import { region } from 'src/config'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'ShortenedUrlForm',
  components: {
    ModelForm
  },
  configuration: ['currentSite'],
  models: {
    shortenedUrl: 'default'
  },
  data () {
    return {
      tooltipMessage: ''
    }
  },
  computed: {
    apiUrl () {
      return `https://api-${region}.indy.systems/url/`
    }
  },
  methods: {
    copyUrl () {
      const clipboard = navigator.clipboard
      if (clipboard === undefined) {
        this.tooltipMessage = 'Unable to copy to clipboard'
        this.$refs.copyUrlTooltip.show()
      } else {
        clipboard.writeText(this.shortenedUrl.shortUrl).then(function () {
          this.tooltipMessage = 'Copied to clipboard!'
          this.$refs.copyUrlTooltip.show()
        }, function () {
          this.tooltipMessage = 'Unable to copy to clipboard'
          this.$refs.copyUrlTooltip.show()
        })
      }
    },
    checkRouteValid (route) {
      return /^[a-zA-Z0-9_-]*$/.test(route)
    }
  }
}

</script>
